import { render, staticRenderFns } from "./PbDivider.vue?vue&type=template&id=4c189f31&"
import script from "./PbDivider.vue?vue&type=script&lang=js&"
export * from "./PbDivider.vue?vue&type=script&lang=js&"
import style0 from "./PbDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports